import Typography from '@mui/material/Typography'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { MeetsFilter } from '../../../components/MeetsFilter/MeetsFilter'
import { BlockWrapper } from '../../../components/Wrapper/BlockWrapper'
import { HeaderWrapper } from '../../../components/Wrapper/HeaderWrapper'
import { TitleWrapper } from '../../../components/Wrapper/TitleWrapper'
import { useAssistantAdministrationStore } from '../../../store/storeAssistantAdministration'
import { useWrapperStore } from '../../../store/storeWrapper'
import { Meets } from './components/Meets'

export const MeetsPage = () => {
    const [searchParams] = useSearchParams()
    const { fetchMeeting } = useAssistantAdministrationStore((state) => state)
    const { projectListActive } = useWrapperStore((state) => state)

    const searchParamWorkplaceId = searchParams.get('workplaceId')

    useEffect(() => {
        fetchMeeting({ workplace_id: searchParamWorkplaceId })
    }, [searchParamWorkplaceId])

    return (
        <BlockWrapper>
            <HeaderWrapper>
                <Typography variant="h4">Календарь</Typography>
                <TitleWrapper>
                    {projectListActive && <MeetsFilter projectList={projectListActive} />}
                </TitleWrapper>
            </HeaderWrapper>
            <Meets />
        </BlockWrapper>
    )
}
